'use strict';

import $ from 'jquery';
import * as globalisation from '../../utilities/globalisation';
import ModalView from '../../js/components/ModalView';
import templateForgotPassword from './templates/_ForgotPasswordModal.hbs';
import successTemplate from './templates/_ForgotPasswordModalSuccess.hbs';
import config from '../../js/config';
import * as featureFlags from '../../utilities/featureFlags';
import analytics from '../Analytics/Analytics';
let instance = null;

export default class ForgotPasswordForm extends ModalView {
  initialize() {
    super.initialize({ template: templateForgotPassword, remodal: { closeOnOutsideClick: false } });
  }

  initializeElements() {
    this.$form = this.$('.ForgotPasswordForm');
    this.$errors = this.$('.ForgotPassword-modal-errors');
    this.$errorsApi = this.$('.ForgotPassword-api-errors');
    this.$errorsApiForgotten = this.$('.ForgotPassword-api-forgotten');
    this.$email = this.$('#ForgotPasswordForm-email');
    this.$submitButton = this.$('#ForgotPasswordForm-submit');
    this.$emailLabel = this.$('.ForgotPasswordForm-container--full').find('label');
    this.$firstFocusableElement = this.$('.Modal-close.Icon.Icon--cross');
    this.$lastFocusableElement = this.$('#ForgotPasswordForm-submit');
    let $dlgDiv = $('.remodal.remodal-is-initialized').parent();
    if ($dlgDiv && $dlgDiv.length) {
      $dlgDiv.attr('role','dialog');
      $dlgDiv.attr('aria-modal',true);
      $dlgDiv.attr('aria-labelledby','Modal-header');
      $dlgDiv.attr('aria-describedby','ForgotPasswordForm-emailQuote');
    }

    this.$errorsApi.hide();
  }

  /**
   * Handle the click event to open the Forgot Password modal
   *
   * @param {Event} e
   */
  static handleOpenerClicked(e) {
    e.preventDefault();
    ForgotPasswordForm.getInstance().open();
  }

  open() {
    this.renderModal();
    if (featureFlags.EnableAdobeAnalytics.isEnabled()) {
      analytics.pushFormInteractionData('form_start', 'Forgot Password');
    }
    this.customerSupportPhone = config.customerSupport.customerSupportPhone;
    this.modalData = { customerSupportPhone: this.customerSupportPhone }
    super.open(this.modalData);
  }

  modalClosing() {
    super.modalClosing();
    $('.LoginForm-passwordLink.LoginPage-passwordLink').focus();
  }

  renderModal() {
    // Render main view
    this.$el.html(this.template());
  }

  _getValidatorConfig() {
    let emailTranslation = globalisation.pluraliseAndTranslate('forms', 'email');
    return {
      errorClass: config.classes.isInvalid,
      validClass: config.classes.isValid,
      errorElement: 'strong',
      wrapper: 'li',
      errorLabelContainer: this.$errors,
      ignoreTitle: true,
      messages: {
        email: {
          required: globalisation.pluraliseAndTranslate('formValidation', 'requiredFieldName', { fieldName: emailTranslation }),
          email: globalisation.pluraliseAndTranslate('formValidation', 'email')
        }
      }
    }
  }

  initializeEvents() {
    $('#ForgotPasswordForm-email').focus();
    $('#ForgotPasswordForm-email').keyup(() => {
      if (this.validator.numberOfInvalids()) {
        this.$errorsApi.hide();
      }
    });
    this.$firstFocusableElement.on('keydown',(e)=>{
      if (e.key === 'Tab' && e.shiftKey) {
        e.preventDefault();
        this.$lastFocusableElement.focus();
      }
    });
    this.$lastFocusableElement.on('keydown', (e)=>{
      if (e.key === 'Tab' && !e.shiftKey) {
        e.preventDefault();
        this.$firstFocusableElement.focus();
      }
    });
  }

  createValidator() {
    this.validator = this.$form.validate(this._getValidatorConfig());
    this.initializeEvents();
  }

  onOpen() {
    this.initializeElements();
    this.createValidator();
  }

  onConfirm() {
    // Already doing something
    if (this.$form.hasClass(config.classes.loadingClass)) {
      return;
    }

    if (!this.validator.form()) {
      $('#ForgotPasswordForm-email').focus();
      analytics.pushFormErrorData('Forgot Password', this.getErrorMessages());
    }

    if (!this.validator.numberOfInvalids()) {
      this.requestResetPassword();
    }
  }

  requestResetPassword() {
    this.showGenericMessage();
    this.$submitButton.addClass(config.classes.loadingClass);
    let emailAddress = encodeURI(this.$email.val());
    let promise = this.ajaxRequest(config.urls.login.forgotPasswordUrl, emailAddress);
    promise.done((response) => {
      response.data;
      if (featureFlags.EnableAdobeAnalytics.isEnabled()) {
        if (response.data.success) {
          analytics.pushFormInteractionData('form_submit', 'Forgot Password');
        } else {
          analytics.pushFormErrorData('Forgot Password', this.getErrorMessages());
        }
      }
    });
  }

  ajaxRequest(requestUrl, emailAddress) {
    if (featureFlags.EnablePostParameterRemediation.isEnabled()) {
      const data = {
        'username': emailAddress
      };
      const requestOptions = {
        url: requestUrl,
        dataType: 'json',
        contentType: 'application/json; charset=utf-8',
        method: 'POST',
        async: false,
        data: JSON.stringify(data)
      };
      return $.ajax(requestOptions);
    } else {
      let url = requestUrl + emailAddress;
      return $.ajax({
        method: 'POST',
        dataType: 'json',
        url: url,
        context: document.body
      });
    }
  }

  getErrorMessages() {
    let error_messages = [];
    let $formError = this.$errors.find('.is-invalid');
    let $apiError = this.$errorsApi.find('li');
    let $forgottenAccount = this.$errorsApiForgotten.find('li');
    if ($formError.css('display') === 'inline') {
      error_messages.push({
        error_message: $formError.text() || undefined,
        form_field_type: this.$emailLabel.text().replace('*', '') || undefined
      });
    }
    if ((this.$errorsApi.css('display') === 'inline') || (this.$errorsApi.css('display') === 'block')) {
      error_messages.push({
        error_message: $apiError.text() || undefined,
        form_field_type: undefined
      });
    }
    if ((this.$errorsApiForgotten.css('display') === 'inline') || (this.$errorsApiForgotten.css('display') === 'block')) {
      error_messages.push({
        error_message: $forgottenAccount.text() || undefined,
        form_field_type: undefined
      });
    }
    return error_messages;
  }

  showSuccess() {
    this.$el.html(successTemplate());
  }

  showGenericMessage() {
    this.hideErrors();
    this.$el.html(successTemplate());
  }

  hideErrors() {
    this.$errorsApi.hide();
    this.$errorsApiForgotten.hide();
  }

  showError() {
    this.$submitButton.removeClass(config.classes.loadingClass);
    this.$errorsApi.show();
  }

  showForgottenError() {
    this.$submitButton.removeClass(config.classes.loadingClass);
    this.$errorsApiForgotten.show();
  }


  /**
   * Get the singleton instance of the ForgotPasswordForm.
   *
   * @returns {ForgotPasswordForm}
   */
  static getInstance() {
    if (!instance) {
      instance = new ForgotPasswordForm();
    }

    return instance;
  }

}

export function createForgotPasswordForm($parent) {
  let $forgotPasswordButton = $parent.find('.LoginPage-passwordLink');

  if ($forgotPasswordButton.length) {
    $forgotPasswordButton.on('click', ForgotPasswordForm.handleOpenerClicked);
  }

}



// WEBPACK FOOTER //
// ./assets/components/Login/ForgotPasswordForm.js